var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticlesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15H15.5V12.5H10.5V15ZM10.5 11.25H20.5V8.75H10.5V11.25ZM10.5 7.5H20.5V5H10.5V7.5ZM8 20C7.3125 20 6.72417 19.7554 6.235 19.2663C5.745 18.7763 5.5 18.1875 5.5 17.5V2.5C5.5 1.8125 5.745 1.22375 6.235 0.73375C6.72417 0.244583 7.3125 0 8 0H23C23.6875 0 24.2763 0.244583 24.7663 0.73375C25.2554 1.22375 25.5 1.8125 25.5 2.5V17.5C25.5 18.1875 25.2554 18.7763 24.7663 19.2663C24.2763 19.7554 23.6875 20 23 20H8ZM8 17.5H23V2.5H8V17.5ZM3 25C2.3125 25 1.72417 24.7554 1.235 24.2663C0.745 23.7763 0.5 23.1875 0.5 22.5V5H3V22.5H20.5V25H3Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesIcon);
export default __webpack_public_path__ + "static/media/articlesIcon.69addac12b60e86aa9f5aa5c4a957421.svg";
export { ForwardRef as ReactComponent };